import { Directive, forwardRef } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import {MitsFormInputComponent} from '../mits-form-input.component';

/**
 * Direktive, zur Nutzung der MitsFormInputComponent in Angular Reactive Forms
 */
@Directive({
  selector: 'mits-form-input[formControlName]',
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => MitsFormInputControlValueAccessorDirective),
      multi: true
    }
  ],
  standalone: true
})
export class MitsFormInputControlValueAccessorDirective implements ControlValueAccessor {
  constructor(private host: MitsFormInputComponent) {
    // Hört auf die Änderungen in der Komponente und meldet sie an Angular Forms
    this.host.valueChange.subscribe((value) => {
      this.onChange(value);
    });
  }

  /**

  /**
   * Wird von FormControl aufgerufen, um den Wert zu setzen
   * @param value - Wert, der gesetzt werden soll
   */
  writeValue(value: string): void {
    this.host.value = value;
  }

  /**
   * Registriert die Callback-Funktion, die aufgerufen wird, wenn sich der Wert in der Komponente ändert
   * @param fn - Callback-Funktion der Parent-Komponente
   */
  registerOnChange(fn: never): void {
    this.onChange = fn;
  }

  /**
   * Registriert die Callback-Funktion, die aufgerufen wird, wenn der Nutzer das Formularfeld "berührt"
   * @param fn - Callback-Funktion der Parent-Komponente
   */
  registerOnTouched(fn: never): void {
    this.onTouched = fn;
  }

  /**
   * Wird von FormControl aufgerufen, um das Formularfeld zu aktivieren/deaktivieren
   * @param isDisabled - Boolean, der angibt, ob das Formularfeld deaktiviert werden soll
   */
  setDisabledState?(isDisabled: boolean): void {
    this.host.disabled = isDisabled;
  }

  /**
   * Callback-Funktion, die aufgerufen wird, wenn sich der Wert in der Komponente ändert
   * @param _ - Der neue Wert
   */
    // eslint-disable-next-line @typescript-eslint/no-unused-vars,@typescript-eslint/no-empty-function
  private onChange = (_: string | undefined): void => {
  };

  /**
   * Callback-Funktion, die aufgerufen wird, wenn der Nutzer das Formularfeld "berührt"
   */
    // eslint-disable-next-line @typescript-eslint/no-empty-function
  private onTouched = (): void => {
  };
}
